import { render, staticRenderFns } from "./comment-modal.vue?vue&type=template&id=8703ac6a&"
import script from "./comment-modal.vue?vue&type=script&lang=js&"
export * from "./comment-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports